<ng-container [formGroup]="form">
    <div class="radio-wrapper" *ngFor="let option of options">
        <input class="simple" (change)="updateModel(option.value)" [formControlName]="name" [value]="option.value" type="radio" [name]="name" [id]="name + '_' + option.value" [required]="required" [checked]="model == option.value">
        <label class="radio" [for]="name + '_' + option.value"><i [class.twingle-radio-unchecked]="model != option.value" [class.twingle-radio-checked]="model == option.value"></i><span [innerHTML]="option.labeltext"></span></label>
    </div>
</ng-container>
